(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sos-vault-models"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sos-vault-models')) {
  customElements.define('sos-vault-models', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => this.initialize());
    }
    initialize() {
      if (this.ready || !this.isConnected) return;
      this.form = this.closest('form');
      const config = this.querySelector('[data-vault-config]');
      if (!this.form || !config) return;
      this.config = JSON.parse(config.textContent);
      this.model = this.querySelector('[data-vault-model]');
      this.native = this.querySelector('[data-vault-native]');
      this.hand = this.querySelector('[data-vault-hand]');
      this.handWrap = this.querySelector('[data-vault-hand-wrap]');
      this.includes = this.querySelector('[data-vault-includes]');
      this.master = this.form.querySelector('select[name="id"]');
      this.optionInputs = [...this.form.querySelectorAll('select[data-index]')];
      this.size = this.optionInputs.find(input => input.dataset.index === `option${this.config.sizeIndex + 1}`);
      if (!this.size || !this.master) return;
      this.ready = true;
      this.money = new Intl.NumberFormat(this.config.locale || 'en-US', {style: 'currency', currency: this.config.currency || 'USD'});
      this.size.required = true;
      this.master.required = true;
      const presentIds = new Set([...this.master.options].map(option => option.value));
      this.config.variants.forEach(variant => {
        if (presentIds.has(String(variant.id))) return;
        const option = new Option(variant.title, String(variant.id));
        option.disabled = !variant.available;
        this.master.add(option);
      });
      this.onChange = this.onChange.bind(this);
      this.onSubmit = this.onSubmit.bind(this);
      this.form.addEventListener('change', this.onChange, true);
      this.form.addEventListener('submit', this.onSubmit, true);
      this.querySelectorAll('[data-key]').forEach(option => {
        const value = option.value === 'Golf' ? 'Golf — Left hand' : option.value;
        const variant = this.config.variants.find(v => v.options[this.config.modelIndex] === value);
        option.dataset.label ||= option.textContent;
        if (variant) option.textContent = `${option.dataset.label} — ${this.money.format(variant.price / 100)}`;
      });
      const initial = this.config.variants.find(v => String(v.id) === String(this.config.initialId));
      if (initial) {
        const value = initial.options[this.config.modelIndex];
        this.model.value = value.startsWith('Golf — ') ? 'Golf' : value;
        this.hand.value = value.startsWith('Golf — ') ? value.slice(7) : '';
      }
      this.synchronize(false);
    }
    disconnectedCallback() {
      if (!this.ready) return;
      this.form.removeEventListener('change', this.onChange, true);
      this.form.removeEventListener('submit', this.onSubmit, true);
      this.ready = false;
    }
    selectedNativeModel() {
      return this.model.value === 'Golf' ? `Golf — ${this.hand.value || 'Left hand'}` : this.model.value || 'Rad / Regular';
    }
    matches(variant) {
      return this.optionInputs.every(input => variant.options[Number(input.dataset.index.slice(6)) - 1] === input.value);
    }
    synchronize(notify) {
      const key = this.model.selectedOptions[0]?.dataset.key || '';
      const golf = key === 'golf';
      this.dataset.model = key;
      this.handWrap.hidden = !golf;
      this.hand.disabled = !golf;
      this.hand.required = golf;
      if (!golf) this.hand.value = '';
      this.native.value = this.selectedNativeModel();
      const choices = this.config.variants.filter(v => v.options[this.config.modelIndex] === this.native.value);
      const sizes = new Set(choices.map(v => v.options[this.config.sizeIndex]));
      [...this.size.options].forEach(option => {
        if (!option.value) return;
        option.disabled = !sizes.has(option.value);
        option.hidden = option.disabled;
      });
      if (!sizes.has(this.size.value)) {
        if (![...this.size.options].some(option => !option.value)) {
          const placeholder = new Option(this.config.chooseSize, '');
          placeholder.disabled = true;
          this.size.prepend(placeholder);
        }
        this.size.value = '';
      }
      this.querySelectorAll('[data-vault-details]').forEach(panel => panel.hidden = panel.dataset.vaultDetails !== key);
      this.includes.disabled = !key;
      this.includes.value = golf ? this.config.golfIncludes : this.config.pairIncludes;
      const variant = this.config.variants.find(v => this.matches(v));
      this.model.setCustomValidity(key && !choices.length ? this.config.selectionRequired : '');
      if (notify) {
        this.syncing = true;
        this.native.dispatchEvent(new Event('change', {bubbles: true}));
        this.syncing = false;
      }
      const complete = !!key && !!this.size.value && (!golf || !!this.hand.value) && variant?.available;
      this.master.value = complete ? String(variant.id) : '';
      const priced = variant || choices[0];
      if (notify && priced) {
        const section = this.form.closest('.product-section');
        const price = section?.querySelector('[id^="ProductPrice-"]');
        if (price) price.textContent = this.money.format(priced.price / 100);
      }
      return complete;
    }
    onChange(event) {
      if (this.syncing || ![this.model, this.hand, ...this.optionInputs].includes(event.target)) return;
      this.synchronize(true);
    }
    onSubmit(event) {
      const complete = this.synchronize(false);
      if (!complete || !this.form.reportValidity()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        this.form.reportValidity();
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
